import { InjectionToken } from '@angular/core';

export const CLIENT_USER_SESSION_KEY = 'userSession';

export const USER_SESSION_TOKEN = new InjectionToken<string>('USER_SESSION_KEY');
